import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type CalendarPlus01IconProps = IconProps

const CalendarPlus01Icon = forwardRef<SVGSVGElement, CalendarPlus01IconProps>(
  (props: CalendarPlus01IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 8H3m13-6v3M8 2v3m4 13v-6m-3 3h6m-7.2 7h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
        fill="none"
      ></path>
    </Icon>
  ),
)

CalendarPlus01Icon.displayName = 'CalendarPlus01Icon'
CalendarPlus01Icon.defaultProps = iconDefaultProps

export type { CalendarPlus01IconProps }
export { CalendarPlus01Icon }
